<template>
   <div class="container px-0 bg-danger">
      <div class="offcanvas offcanvas-end rounded-2 shadow bg-light" 
            data-bs-scroll="true" 
            data-bs-backdrop="true" 
            tabindex="-1" 
            id="offcanvasMoveShared" 
            aria-labelledby="offcanvasMoveSharedLabel"
            >
         <div class="offcanvas-header">
            <h6 v-if="moveOrSharedTxt == 'USH'" id="offcanvasMoveSharedLabel">Finalizar Intervención</h6>
            <h6 v-else-if="moveOrSharedTxt == 'UMS'" id="offcanvasMoveSharedLabel">Regresar al Tablero Origen</h6>
            <h6 v-else id="offcanvasMoveSharedLabel">{{txtHeader}} otro Tablero</h6>
            <button 
               id="bttCloseOcMoveShared"
               type="button" 
               class="btn-close btn-sm text-reset me-0" 
               data-bs-dismiss="offcanvas" 
               aria-label="Close" 
               ref="btn_out_oc_move_shared"
               ></button>
         </div>
         <hr class="m-0 p-0"/>
         <!-- <hr class="m-0 p-0"/> -->
         <div class="offcanvas-body gap-0 mt-0 py-2">
            <!--
            <div v-if="moveOrSharedTxt != 'USH'" class="mt-0 pb-2">{{txtHeader}}:</div>
            <!- {{boards}} ->
            <div v-if="moveOrSharedTxt != 'USH'" class="accordion accordion-flush" id="accordionFlushBoards">
            -->
            <div v-if="'.USH.UMS.'.indexOf( moveOrSharedTxt ) < 0 " class="mt-0 pb-2">{{txtHeader}}:</div>
            <!-- {{boards}} -->
            <div v-if="'.USH.UMS.'.indexOf( moveOrSharedTxt ) < 0 " class="accordion accordion-flush" id="accordionFlushBoards">
               <div v-for="(board, index) in boards" :key="index" class="accordion-item">
                  <h2 class="accordion-header" :id="'flush-heading-' + board.shortName">
                  <button class="accordion-button collapsed" 
                        type="button" data-bs-toggle="collapse" 
                        :data-bs-target="'#flush-collapse-' + board.shortName" aria-expanded="false" 
                        :aria-controls="'flush-collapse-' + board.shortName"
                        >
                  <!-- 
                        @click="boardToId = board.id"
                  -->
                  <div class="container">
                     <div class="row justify-content-between">
                        <div class="col-2 text-center p-0">
                     <board-rectangle 
                        :board="board"
                        :selected="board.selected"
                        :small="false"
                        :cellName="false"
                        class="ms-1 pb-0"
                        />
                        </div>
                        <div class="col-10 ps-2">
                           {{board.name}}
                        </div>
                     </div>
                  </div>
                  </button>
                  </h2>
                  <div :id="'flush-collapse-' + board.shortName" class="accordion-collapse collapse" :aria-labelledby="'flush-heading-' + board.shortName" data-bs-parent="#accordionFlushBoards">
                     <div class="accordion-body p-0 pt-2">
                              <!-- class="form-check row row-cols-auto ps-2 gap-0" 
                                 @click="cellIdToAdd = cell.cellId"
                                 &nbsp; 
                              -->
                        <div v-for="(cell, index) in board.cellsTo" 
                              :key="index" 
                              class="form-check rounded"
                              >
                           <input class="form-check-input ms-0" 
                                 type="radio" :id="cell.cellLabelId" 
                                 :value="cell.cellLabelId" v-model="movePicked" 
                                 @click="selectedCell( cell.cellId, board.id )"
                                 :disabled="cell.isSharedHere"
                                 />
                           <div class="container">
                              <div class="row justify-content-between">
                                 <label v-if="cell.isSharedHere" :for="cell.cellLabelId" class="col-auto text-decoration-line-through">{{cell.cellName}}</label>
                                 <label v-else :for="cell.cellLabelId" class="col-auto">{{cell.cellName}}</label>
                                 <div class="col-auto">
                                    <labelRectangle v-if="cell.label"
                                       :label="cell.label"
                                       :format="'label'"
                                    />
                                    <div v-else>
                                       &nbsp;
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div v-else-if="moveOrSharedTxt == 'USH'">
               <p>La operación de Finalizar la Intervención QUITARA esta tarjeta de este tablero.</p>
               <hr class="m-0 p-0"/>
            </div>
            <div v-else>
               <p>La operación Regresar al Tablero Origen MOVERÁ esta tarjeta al tablero que la envió a esta lista.</p>
               <hr class="m-0 p-0"/>
            <!-- {{boards}} -->
            </div>
            <!-- <hr /> -->
            <div v-if="movePicked != 0" class="accordion accordion-flus mt-2" id="accordionFlushComment">
               <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingOne">
                     <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                     Comentario
                     </button>
                  </h2>
                  <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushComment">
                     <div class="accordion-body container py-2">
                        <div class="row justify-content-between">
                           <div class="col-10 ps-0">
                              <!--
                                 @blur="getOut()"
                                 @keyup="onChange($event)"
                                 @keyup="onChange($event)"
                              -->
                              <textarea 
                                 class="form-control" id="ta-comment" 
                                 v-model="textComment"
                                 placeholder="Escriba un comentario aquí..." 
                                 rows="3" 
                                 @focus="onChange"
                                 @keyup="onChange"
                              ></textarea>
                           </div>
                           <div class="col-2 text-center p-0">
                              <button 
                                 type="button" 
                                 class="btn btn-sm p-0 fs-5"
                                 @click="clearArroba()"
                                 :disabled="arrobaDisable"
                                 >
                                 <div v-if="arrobaDisable">@</div>
                                 <b v-else>@</b>
                              </button>
                              <board-rectangle
                                 :board="thisBoard"
                                 :selected="thisBoard.selected"
                                 :small="false"
                                 :cellName="false"
                                 @click="selectThisBoard()"
                                 class="pb-0 my-1"
                                 />
                              <board-rectangle v-if="thisBoard.id != boardTo.id"
                                 :board="boardTo"
                                 :selected="boardTo.selected"
                                 :small="false"
                                 :cellName="false"
                                 @click="selectBoardTo()"
                                 class="pb-0"
                                 />
                           </div>
                        </div>
                        <div v-if="!arrobaDisable" class="row">
                           <div class="col-12 rounded-1 mt-2 border border-1">
                              <div class="row">
                                 <b class="tc-d-gray fs-12">Miembros:</b>
                              </div>
                              <div class="row row-cols-auto p-2">
                                 <div v-for="(circleUser, index) in usersBoard" :key="index" class="col p-0 m-1">
                                    <userCircle 
                                       :circleUser="circleUser" 
                                       class="user-member"
                                       @mouseover="showAlias(index)"
                                       @mouseleave="clearMember()"
                                       @click="addMember(index)"
                                       />
                                 </div>
                                 <!--
                                 -->
                              </div>
                              <div class="hg-mention border border-1 rounded mb-1">
                                 <div class="text-center">
                                    {{member.name}}
                                 </div>
                                 <div class="text-center">
                                    {{member.arroba}}
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <!-- <hr v-if="movePicked != 0" /> -->
            <!-- {{boards}} 
                              <div>{{boardTo}}</div>
               <button v-if="movePicked != 0"  class="btn btn-primary" :disabled="moving" @click="moveShareTo(movePicked)">
               <button v-if="addComment"  class="btn btn-secondary" :disabled="moving">
                  Agregar un Comentario
               </button>
            -->
            <div class="d-grid py-2 gap-2">
               <button v-if="movePicked != 0"  class="btn btn-primary" :disabled="moving" @click="moveShareTo(movePicked)">
                  <span v-show="moving" class="spinner-border spinner-border-sm"></span>
                  {{txtBttMove}}
               </button>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
//import { ref, onMounted, nextTick, watchEffect } from 'vue';
import { ref, onMounted, nextTick } from 'vue'
import { useStore } from 'vuex'

import WspService from "../workSpace.service";
import BoardRectangle from "./BoardRectangle.vue";
import labelRectangle from '../components/LabelRectangle.vue';
import userCircle from '/src/components/UserCircle.vue';


export default {
   components: {
      BoardRectangle,
      labelRectangle,
      userCircle
   },
   setup() {
      const store = useStore()
      const cnttId = ref(store.state.wspace.contentId)
      const moveOrSharedTxt = ref("xxx")

      const boardId = ref(null)
      const cellId = ref(0)
      const cellContentId = ref(0)
      const cardTypeId = ref(0)

      const boards = ref([])
      const movePicked = ref('')
      const txtBttMove = ref('')
      const txtHeader = ref('')
      const moving = ref(false)
      const boardToId = ref(null)
      const cellIdToAdd = ref(null)
 
      //const addComment = ref(false)
      const textComment = ref("")
      const thisBoard = ref({})
      const boardTo = ref({})
      const usersBoard = ref([])
      const arrobaDisable = ref(true)
      const member = ref({})
      const btn_out_oc_move_shared = ref(null)
      const message = ref({})

      onMounted(() => {
         let myOffCanvas = document.getElementById('offcanvasMoveShared')
         myOffCanvas.addEventListener('shown.bs.offcanvas', function (event) {
            cnttId.value = store.state.wspace.contentId
            let button = event.relatedTarget
            moveOrSharedTxt.value = button.getAttribute('data-move-shared')
            cellId.value = button.getAttribute('data-cell-id')
            cellContentId.value = button.getAttribute('data-cellContent-id')
            cardTypeId.value = button.getAttribute('data-card-type-id')
            //
            member.value = {
               name: '',
               arroba: ''
            }
            message.value = {}
            boards.value = []
            usersBoard.value = []
            moving.value = false
            arrobaDisable.value = true
            textComment.value = ""
            //addComment.value = false
            boardId.value = WspService.getBoardId(store)
            if ( moveOrSharedTxt.value == "RMV" ) {
               getBoardsTo("RMV")
               txtBttMove.value = 'Mover'
               txtHeader.value = 'Mover a'
            }
            if ( moveOrSharedTxt.value == "SHR" ) {
               getBoardsTo("SHR")
               txtBttMove.value = 'Compartir'
               txtHeader.value = 'Compartir con'
            }
            if ( moveOrSharedTxt.value == "USH" ) {
               getBoardsTo("USH")
               txtBttMove.value = 'Finalizar Intervención'
            }
            if ( moveOrSharedTxt.value == "UMS" ) {
               getBoardsTo("UMS")
               txtBttMove.value = 'Regresar al Tablero Origen'
            }
            movePicked.value = 0
            myOffCanvas.focus()
            console.log("data-cellContent-id: " + moveOrSharedTxt.value)
         })
      })

      function getBoardsTo(moveShare) {
         WspService.getBoardsTo(
            boardId.value, 
            cardTypeId.value, 
            cnttId.value, 
            moveShare )
         .then(response => {
            //console.log(response.data)
            boards.value = response.data
            //if ( moveShare == "USH" ) {
            if ( ".USH.UMS.".indexOf( moveShare ) > -1  ) {
               selectedCell( 0, boards.value[0].id )
               nextTick(() => { movePicked.value = boards.value[0].cellsTo[0].cellLabelId })
            }
            //cells.value = response.data
            //console.log("colors ok: "+colors.value)
         })
         .catch(error => {
            console.log(error);
         });
      }

      function moveShareTo(cellLabelIdToAdd) {
         console.log(cellLabelIdToAdd)
         moving.value = true
         let negativeId = -8
         if ( moveOrSharedTxt.value == "RMV" ) {
            txtBttMove.value = 'Moviendo'
         }
         if ( moveOrSharedTxt.value == "SHR" ) {
            txtBttMove.value = 'Compartiendo'
            negativeId = -11
         }
         if ( moveOrSharedTxt.value == "USH" ) {
            txtBttMove.value = 'Finalizando Intervención'
            negativeId = -12
         }
         if ( moveOrSharedTxt.value == "UMS" ) {
            txtBttMove.value = 'Regresando al Tablero Origen'
         }
         /*
         if ( textComment.value.length > 0 ) {
            addComment(cellLabelIdToAdd, negativeId)
         } else {
            addAuditMs(cellLabelIdToAdd, negativeId)
         }
         */
         addAuditMs(cellLabelIdToAdd, negativeId)
      }

      function addAuditMs(cellLabelIdToAdd, negativeId) {
         WspService.addAuditMoveOrShared(
               cnttId.value, 
               moveOrSharedTxt.value,
               store.state.auth.user.id, 
               textComment.value,            //null,
               cellId.value,
               boardId.value,
               boardToId.value,
               cellLabelIdToAdd,
               moveOrSharedTxt.value
               )
         .then(response => {
            //store.dispatch("wspace/setContentId", moveOrSharedTxt.value == "RMV" ? -8 : -11)       // -8
            //store.dispatch("wspace/setContentId", negativeId)
            console.log(response);
            message.value = response.data
            if ( message.value.statusCode == 0 ) {
               setTimeout( setStore, 6000, negativeId )
            } else {
               alert( message.value.message )
               setTimeout( setStore, 2000, message.value.statusCode )
            }
         })
         .catch(error => {
            console.log(error);
         });
      }
      
      function setStore( negativeId ) {
         store.dispatch( "wspace/setContentId", negativeId )
         btn_out_oc_move_shared.value.click()
      }
      /*
      function addComment(cellLabelIdToAdd, negativeId) {
         console.log(cellLabelIdToAdd)
         WspService.addAuditMoveOrShared(
               cnttId.value, 
               "CMM", 
               store.state.auth.user.id, 
               textComment.value,
               cellId.value,
               boardId.value,
               boardToId.value,
               cellLabelIdToAdd,
               moveOrSharedTxt.value
               )
         .then(response => {
            //store.dispatch("wspace/setContentId", -8)
            console.log(response);
            message.value = response.data
            if ( message.value.statusCode == 0 ) {
               addAuditMs(cellLabelIdToAdd, negativeId)
            } else {
               alert( message.value.message )
               setTimeout( setStore, 2000, message.value.statusCode )
            }
         })
         .catch(error => {
            console.log(error);
         });
      }
      */
      function selectedCell( cell_id_to_add, board_to_id ) {
         cellIdToAdd.value = cell_id_to_add     // cellIdToAdd no se usa, revisar
         boardToId.value = board_to_id

         clearArroba()
         textComment.value = ""

         WspService.getBoardRectangle(boardId.value)
         .then(response => {
            thisBoard.value = response.data
         })
         .catch(error => {
            console.log(error);
         });

         WspService.getBoardRectangle(boardToId.value)
         .then(response => {
            boardTo.value = response.data
         })
         .catch(error => {
            console.log(error);
         });
      }

      function selectThisBoard() {
         if ( !thisBoard.value.selected ) {
            thisBoard.value.selected = true
            boardTo.value.selected = false
            arrobaDisable.value = false
            getUsersBoard(thisBoard.value.id)
         }
      }

      function selectBoardTo() {
         if ( !boardTo.value.selected ) {
            boardTo.value.selected = true
            thisBoard.value.selected = false
            arrobaDisable.value = false
            getUsersBoard(boardTo.value.id)
         }
      }

      function clearArroba() {
         usersBoard.value = []
         boardTo.value.selected = false
         thisBoard.value.selected = false
         arrobaDisable.value = true
      }
      
      function getUsersBoard(board_id) {
         //uAppIndex.value = store.state.auth.userAppIndex
         //if (uAppIndex.value > -1) {
         //   uAppModule.value = store.state.auth.userAppModule;

            WspService.getBoardMembers(board_id)
               //uAppModule.value.appModuleComponent[uAppIndex.value].userAppModuleId,
               //contentId,
               //true)
            .then(response => {
               usersBoard.value = response.data
               //console.log(response.data)
            })
            .catch(error => {
               console.log(error);
            });
         //}
      }
      
      function onChange(event) {
         let area = event.target;
         area.style.overflow = 'hidden';
         area.style.height = area.scrollHeight + 'px';
         //diableButton.value = event.target.value.length < 1;
      }

      function clearMember() {
         member.value = {
               name: '',
               arroba: ''
            }
      }

      function showAlias(index) {
         member.value = {
            name: usersBoard.value[index].name,
            arroba: '@' + usersBoard.value[index].arroba
         }
      }

      function addMember(index) {
         textComment.value = textComment.value + '@' + usersBoard.value[index].arroba + ' '
         /*
         let cmm = document.getElementById('ta-comment').value
         document.getElementById('ta-comment').value = cmm + '@' + usersApp.value[index].arroba + ' '
         //document.getElementById('ta-comment').focus()
         btn_out_offcanvas.value.click()
         */
      }

      return {
         //addComment,
         boardId, boards, boardToId,
         btn_out_oc_move_shared,
         cardTypeId,
         cellContentId, cellId, cellIdToAdd,
         cnttId,
         moveOrSharedTxt, movePicked, moveShareTo, moving, txtBttMove, txtHeader,
         selectedCell, selectThisBoard, selectBoardTo,
         textComment, onChange, thisBoard, boardTo, usersBoard, arrobaDisable, clearArroba,
         member, clearMember, showAlias, addMember,
         message
      }
   }
}
</script>

<style scoped>
   .offcanvas-end {
      top: 50px;
      right: 5%;
      width: 600px;
      /*height: fit-content;#ecf0f1*/
   }
   .btn-sm {
      width: max-content;
   }
   .form-check {
      background-color: #f8f8f8;
   }
   .tc-d-gray {
      color: darkslategray;
   }
   .fs-12 {
      font-size: 12px;
   }
   .user-member:hover {
      cursor: pointer;
   }
   .hg-mention {
      height: 60px;
   }
</style>